<template>
  <div class="d-flex flex-wrap">
    <div class="col-3 pl-0">
      <b-card>
        <template #header>
          <i class="fas fa-search"></i> {{$lang.PCI.Reports.Log.LabelSearch}}
        </template>
        <b-form-group :label="$lang.PCI.Reports.LabelReport">
          <v-select label="descricao"
                    :options="form.relatorio.options"
                    v-model="form.relatorio.value"
                    :reduce="value => value.id" />
        </b-form-group>
        <b-form-group :label="$lang.PCI.Reports.Log.LabelPeriod">
          <datepicker name="txtDateStart"
                      v-model="form.dataInicio.value"
                      :format="'dd/MM/yyyy'"
                      :language="ptBR"
                      :placeholder="$lang.Common.DatePlaceholder"
                      :clear-button="true"
                      :clear-button-icon="'fas fa-times'"
                      :calendar-button="true"
                      :calendar-button-icon="'fa fa-calendar'"
                      :bootstrap-styling="true"
                      :full-month-name="true"
                      :initialView="'month'"
                      :use-utc="true"/>
        </b-form-group>
        <b-form-group>
          <datepicker name="txtDateEnd"
                      v-model="form.dataFim.value"
                      :format="'dd/MM/yyyy'"
                      :language="ptBR"
                      :placeholder="$lang.Common.DatePlaceholder"
                      :clear-button="true"
                      :clear-button-icon="'fas fa-times'"
                      :calendar-button="true"
                      :calendar-button-icon="'fa fa-calendar'"
                      :bootstrap-styling="true"
                      :full-month-name="true"
                      :initialView="'month'"
                      :use-utc="true"/>
        </b-form-group>
        <b-form-group class="d-flex justify-content-end">
          <b-button variant="third" @click="onGenerate">{{$lang.PCI.Reports.Log.ButtonGenerate}}</b-button>
        </b-form-group>
      </b-card>
    </div>
    <div class="col-9 px-0">
      <b-card id="card-table" class="mb-0">
        <template #header>
          <div class="d-flex">
            <div>
              <i class="fas fa-print pr-2"></i> {{$lang.PCI.Reports.Log.LabelReport}}
            </div>
            <div class="card-actions">
              <b-link href="#" variant="third" @click="onExport">
                <i class="far fa-file-excel p-1" style="font-size:1rem;cursor:pointer;"></i>
              </b-link>
            </div>
          </div>
        </template>
        <div class="d-flex flex-wrap mb-2">
          <b-checkbox v-model="showAll" @change="onProcessList" switch >{{ $lang.PCI.Reports.Log.LabelShowAll }}</b-checkbox>
          <b-checkbox v-model="showCandidates" @change="onProcessList" switch class="ml-2">{{ 'Exibir Candidatos' }}</b-checkbox>
        </div>

        <ag-grid-vue class="ag-theme-alpine"
                     ref="grid"
                     :getLocaleText="localeTextFunc"
                     :columnDefs="columnDefs"
                     :gridOptions="logsGridOptions"
                     :defaultColDef="defaultColumnDef"
                     :rowData="listToShow"
                     :suppressContextMenu="true"
                     :stopEditingWhenCellsLoseFocus="true"
                     :groupHeaderHeight="45"
                     :headerHeight="45"
                     :rowHeight="30"
                     :excelStyles="excelStyles"
                     :groupDefaultExpanded="2"
                     groupDisplayType="groupRows"
                     style="width:100%;height:calc(100% - 30px);">
        </ag-grid-vue>
      </b-card>
    </div>
  </div>
</template>

<script>
import PCIReportRepository from '@/shared/http/repositories/pci/pcireport'
import Form from './logs-form'
import { loading, toast } from '@/shared/utils/UIHelper'
import CompanyMixin from '@/store/module/company/mixin'
import Datepicker from 'vuejs-datepicker'
import {ptBR} from 'vuejs-datepicker/dist/locale'
import Tools from '@/components/tools/Tools'
import PCIRepository from '@/shared/http/repositories/pci/pci'
import { AgGridVue } from 'ag-grid-vue'
import gridMixin from '../mixins/gridMixin'
import moment from 'moment'

export default {
  name: 'Logs',
  mixins: [CompanyMixin, gridMixin],
  components: {
    Datepicker,
    AgGridVue
  },
  data () {
    return {
      form: Form,
      ptBR: ptBR,
      objList: [],
      listToShow: [],
      logsGridOptions: {},
      showAll: false,
      showCandidates: false,
      columnDefs: []
    }
  },
  mounted () {
    this.form.dataFim.value = new Date()
    this.columnDefs = this.getColumnDefs()
    this.loadReports()
  },
  methods: {
    getColumnDefs () {
      return [{
        headerName: 'Item',
        valueGetter: params => {
          var result = params.data ? `ITEM: [${params.data.pciObraItemValor.pciModeloItem.codigo}]-${params.data.pciObraItemValor.pciModeloItem.descricao}` : ''
          return result
        },
        hide: true,
        rowGroup: true,
        width: 230
      },
      {
        headerName: 'Contrato',
        field: 'pciObraItemValor.obra.contrato.referencia',
        width: 250
      },
      {
        headerName: 'Obra (Cód.)',
        field: 'pciObraItemValor.obra.referencia',
        width: 150
      },
      {
        headerName: 'ID Site',
        field: 'pciObraItemValor.obra.idSite',
        width: 150
      },
      {
        headerName: 'Cand.',
        valueGetter: params => {
          var result = params.data ? params.data.pciObraItemValor.obraCandidato.identificacao : ''
          return result
        },
        hide: !this.showCandidates,
        width: 85
      },
      {
        headerName: 'Atualização',
        valueGetter: params => {
          var result = params.data ? new Date(params.data.dataAcao).toLocaleString().replace(',', '') : ''
          return result
        },
        width: 150
      },
      {
        headerName: 'Usuário Atualização',
        field: 'nomeContaAcao',
        width: 250
      },
      {
        headerName: 'Valor Atual',
        valueGetter: params => {
          var result = ''
          if (params.data) {
            result = params.data.valorAlterado
            if (params.data.valorAlterado === '') {
              result = '[CAMPO VAZIO]'
            } else if (params.data.valorAlterado !== '#NA#' && params.data.pciObraItemValor.pciModeloItem.tipo === 0) {
              if (params.data.pciObraItemValor.pciModeloItem.tipoDados === 1) {
                result = moment(params.data.valorAlterado.substring(0, 10), 'YYYY-MM-DD').toDate().toLocaleDateString()
              } else if (params.data.pciObraItemValor.pciModeloItem.tipoDados === 4) {
                result = parseFloat(params.data.valorAlterado).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2})
              }
            }
          }
          return result
        },
        width: 150
      }]
    },
    loadReports () {
      loading.push()
      PCIReportRepository.GetAll(this.company.id)
        .then(response => {
          if (response.data.code > 0) {
            this.form.relatorio.options = response.data.data.filter(r => r.tipo === 1)
          }
        })
        .finally(() => loading.close())
    },
    onGenerate () {
      if (Tools.ValidateForms(this.form, null, this, toast)) {
        loading.push()
        PCIRepository.GetLogReport(this.form.relatorio.value, this.form.dataInicio.value.toISOString(), this.form.dataFim.value.toISOString())
          .then(response => {
            if (response.data.code > 0) {
              this.objList = response.data.data
              this.onProcessList()
            }
          })
          .finally(() => loading.close())
      }
    },
    onProcessList () {
      if (this.showAll) {
        this.showCandidates = true
        this.listToShow = this.objList
      } else if (this.showCandidates) {
        this.listToShow = this.objList.reduce((acc, obj) => {
          if (acc.length) {
            const lastObj = acc[acc.length - 1]
            if (!(
              lastObj.pciObraItemValor.pciModeloItem.codigo === obj.pciObraItemValor.pciModeloItem.codigo &&
              lastObj.pciObraItemValor.obra.contrato.referencia === obj.pciObraItemValor.obra.contrato.referencia &&
              lastObj.pciObraItemValor.obra.referencia === obj.pciObraItemValor.obra.referencia &&
              lastObj.pciObraItemValor.obraCandidato.identificacao === obj.pciObraItemValor.obraCandidato.identificacao
            )) {
              acc.push(obj)
            }
          } else {
            acc.push(obj)
          }
          return acc
        }, [])
      } else {
        this.showAll = false
        this.listToShow = this.objList
          .filter(obj => obj.valorAlterado !== '#NA#')
          .reduce((acc, obj) => {
            if (acc.length) {
              const lastObj = acc[acc.length - 1]
              if (!(
                lastObj.pciObraItemValor.pciModeloItem.codigo === obj.pciObraItemValor.pciModeloItem.codigo &&
                lastObj.pciObraItemValor.obra.contrato.referencia === obj.pciObraItemValor.obra.contrato.referencia &&
                lastObj.pciObraItemValor.obra.referencia === obj.pciObraItemValor.obra.referencia &&
                lastObj.pciObraItemValor.obraCandidato.identificacao === obj.pciObraItemValor.obraCandidato.identificacao
              )) {
                acc.push(obj)
              }
            } else {
              acc.push(obj)
            }
            return acc
          }, [])
          .reduce((acc, obj) => {
            if (acc.length) {
              const lastObj = acc[acc.length - 1]
              if (!(
                lastObj.pciObraItemValor.pciModeloItem.codigo === obj.pciObraItemValor.pciModeloItem.codigo &&
                lastObj.pciObraItemValor.obra.contrato.referencia === obj.pciObraItemValor.obra.contrato.referencia &&
                lastObj.pciObraItemValor.obra.referencia === obj.pciObraItemValor.obra.referencia
              )) {
                acc.push(obj)
              } else if ((obj.valorAlterado || '9999-12-31') < (lastObj.valorAlterado || '9999-12-31')) {
                acc.splice([acc.length - 1], 1, obj)
              }
            } else {
              acc.push(obj)
            }
            return acc
          }, [])
      }
      this.logsGridOptions.api.setColumnDefs(this.getColumnDefs())
      this.$nextTick(() => {
        this.logsGridOptions.api.sizeColumnsToFit()
      })
    },
    onExport () {
      if (this.objList.length) {
        this.logsGridOptions.api.exportDataAsExcel()
      }
    }
  }
}
</script>

<style scoped>
fieldset {
  padding-bottom: 1rem;
}
#card-table > .card-body {
  height:calc(100vh - 230px)
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/reports/logs.vue